export default __webpack_public_path__ + "static/media/circleError.b3d0765b.svg";